module.exports = __webpack_public_path__ + "static/media/old.ec00a975.png";